import { type FC, type ReactNode, type PropsWithChildren } from 'react';

import type { IconTypes } from '@vakantiesnl/components/src/atoms/Icon';

import { BaseSingleSelect, type BaseSingleSelectProps } from './BaseSingleSelect';
import { SelectBarContent } from '../SelectBarContent/SelectBarContent';

export type SingleSelectProps = Omit<BaseSingleSelectProps, 'content'> & {
	/** Title for the single select component */
	title?: ReactNode;
	icon?: IconTypes;
	image?: string;
};

export const SingleSelect: FC<PropsWithChildren<SingleSelectProps>> = (props) => {
	const { icon, title, dataCy, children } = props;

	return (
		<BaseSingleSelect
			{...props}
			content={
				<SelectBarContent icon={icon} title={title} dataCy={dataCy}>
					{children}
				</SelectBarContent>
			}
		/>
	);
};
